import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ViewQuiltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"view_quilt"}/>
}
